/* eslint-disable import/prefer-default-export */
import { atom } from 'recoil'

export const healthState = atom({
  key: 'health',
  default: false,
})

export const userState = atom({
  key: 'user',
})

export const roundingState = atom({
  key: 'rounding',
  default: false,
})

export const totalPriceState = atom({
  key: 'totalPrice',
  default: 0,
})

export const discountPriceState = atom({
  key: 'discountValue',
  default: 0,
})

export const discountTypeState = atom({
  key: 'discountType',
  default: null,
})

export const netPriceState = atom({
  key: 'netPrice',
  default: 0,
})

export const sumPaymentState = atom({
  key: 'sumPayment',
  default: 0,
})

export const editOrder = atom({
  key: 'editOrder',
  default: false,
})

